import styled from 'styled-components';
import { THEME } from '../../config/constants';

export const StyledSemanticSearchLoaderWrapper = styled.div`
  .${THEME.prefixCls}-skeleton-element {
    display: flex;
    flex: 1;
    justify-content: center;
  }
`;
